import { FC, MouseEvent, useState, useMemo } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import omit from 'lodash/omit';

import { getStatusOptions } from '@modules/Stories/helpers/story';
import { useDictionary } from '@cvt/hooks/useDictionary';
import { useStoryCrud } from '@modules/Stories/hooks/useStoryCrud';


type Props = {
  story: Stories.Story,
}

export const ChangeStatusAction: FC<Props> = ({ story }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dictionary = useDictionary();
  const statusOptions = useMemo(() => getStatusOptions(dictionary), [dictionary]);
  const { editStory } = useStoryCrud();


  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = async (nextStatus: Stories.StoryStatus) => {
    handleClose();

    if (story.status === nextStatus) {
      return;
    }

    const nextStory: Stories.Edit = omit({ ...story, status: nextStatus }, ['user']);

    editStory.mutate(nextStory);
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={handleClose}
      >
        <MenuList dense>
          {statusOptions.map(({ value, label }) => (
            <MenuItem
              key={value}
              value={value}
              selected={story.status === value}
              onClick={() => handleMenuClick(value)}
            >
              {label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <IconButton loading={editStory.isPending} size="small" onClick={handleClick}>
        <ExpandMoreIcon fontSize="inherit"/>
      </IconButton>
    </>
  );
};
